import { initials, initialsColor } from '../lib/avatar';

/**
 * The guild's icon, falling back to its initials.
 *
 * Square with a soft radius rather than a circle, so it does not read as one
 * more member avatar — a guild is not a person.
 */
export function GuildMark({
  name,
  src,
  size = 64,
}: {
  name: string;
  src?: string | null;
  size?: number;
}) {
  return (
    <span
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        borderRadius: src ? 0 : Math.round(size * 0.26),
        flexShrink: 0,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        // A real mark is shown as a mark: no tile, no border, no rounded box
        // behind it. Whatever it was cut out of should stay cut out, and
        // whatever is behind it on the page should show through.
        border: src ? 'none' : '1px solid var(--hairline)',
        background: src ? 'transparent' : initialsColor(name),
        color: '#fff',
        fontFamily: 'var(--font-display)',
        fontSize: Math.round(size * 0.36),
        fontWeight: 600,
        userSelect: 'none',
      }}
    >
      {src ? (
        <img src={src} alt="" width={size} height={size} style={{ objectFit: 'contain' }} />
      ) : (
        initials(name)
      )}
    </span>
  );
}
